if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        _koalaPoll: null,

        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });

          this.initKoalaSync();
        },

        initKoalaSync() {
          // Clear any existing poll to prevent stacking
          if (this._koalaPoll) {
            clearInterval(this._koalaPoll);
            this._koalaPoll = null;
          }

          const sectionIdRef = sectionId;

          function getActiveTierPrice() {
            const checkedInput = document.querySelector('.koala-deal__tier__input:checked');
            if (!checkedInput) return null;

            const label = document.querySelector(`label[for="${checkedInput.id}"]`);
            if (!label) return null;

            const titleEl = label.querySelector('.koala-deal__tier__title');
            const titleText = titleEl?.textContent.trim() ?? '';
            const qtyMatch = titleText.match(/\d+/);
            const quantity = qtyMatch ? parseInt(qtyMatch[0], 10) : null;

            const discountedEl = label.querySelector('.koala-deal__tier__price');
            const regularEl = label.querySelector('.koala-deal__tier__regular-price');

            return {
              discounted: discountedEl?.textContent.trim() ?? null,
              regular: regularEl?.textContent.trim() ?? null,
              quantity,
            };
          }

          function updateStickyPrice() {
            const prices = getActiveTierPrice();

            document.querySelectorAll(`.price-sticky-${sectionIdRef}`).forEach((area) => {
              const priceTag = area.querySelector('p.price');
              const compareTag = area.querySelector('.target-compare-at-price');

              if (!priceTag) return;

              if (prices?.discounted) {
                // Show strikethrough regular + discounted price
                priceTag.innerHTML = `
                  <span style="text-decoration:line-through; opacity:0.5; margin-right:6px;">${prices.regular ?? ''}</span>
                  <span>${prices.discounted}</span>
                `;
                if (compareTag) compareTag.classList.add('hidden');
              } else {
                // No tier active — restore from the Eurus-rendered price element
                const eurusPrice = area.querySelector('.target-price');
                if (eurusPrice) {
                  priceTag.innerHTML = eurusPrice.innerHTML;
                }
                if (compareTag) compareTag.classList.remove('hidden');
              }
            });

            // Sync quantity input
            if (prices?.quantity) {
              const qtyInput = document.querySelector(`#Quantity-sticky-${sectionIdRef}`);
              if (qtyInput && qtyInput.value != prices.quantity) {
                qtyInput.value = prices.quantity;
                qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }
          }

          function attachListeners() {
            const inputs = document.querySelectorAll('.koala-deal__tier__input');
            if (!inputs.length) return false;

            inputs.forEach((input) => {
              input.removeEventListener('change', updateStickyPrice);
              input.addEventListener('change', updateStickyPrice);
            });

            updateStickyPrice();
            return true;
          }

          let attempts = 0;
          this._koalaPoll = setInterval(() => {
            attempts++;
            if (attachListeners() || attempts > 40) {
              clearInterval(this._koalaPoll);
              this._koalaPoll = null;
            }
          }, 500);
        },

        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          });

          // Re-sync after Eurus re-renders, but reuse existing listeners
          this.initKoalaSync();
        },

        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },

        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
          if (source && destination) destination.innerHTML = source.innerHTML;
        },

        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }));
    });
  });
}